// Console logging SILENCED for production
// Import early-console-override FIRST to silence all console.* calls
import './utils/early-console-override'
import './utils/logger'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
// LCARS easter-egg theme (body.lcars-mode) — must load after index.css so its
// equal-specificity overrides win the cascade.
import './styles/lcars.css'

// Import Phase 3 optimizations
import { NetworkSwitchManager } from './utils/networkSwitchManager'
import { warmFrontendCache } from './utils/cacheWarmer'

// Create a client with optimized settings for blockchain data
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
})

// Initialize Network Switch Manager for centralized cache invalidation
NetworkSwitchManager.initialize(queryClient)

// Set up global network change listener
window.addEventListener('networkChanged', (event) => {
  const { previousNetwork, currentNetwork } = event.detail
  NetworkSwitchManager.handleNetworkChange(currentNetwork, previousNetwork)
})

// Expose query client globally for backward compatibility
;(window).__REACT_QUERY_CLIENT__ = queryClient

// Warm up frontend cache on startup for better first impression
warmFrontendCache(queryClient).catch(error => {
  // Silenced - no console output
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
